const GreenTheme = {
  primaryColor: "#cbffcb",
  secondaryColor: "#005500",
  tertiaryColor: "#004400",
  fontSize: "15px",
  fontFamily: "font-family: 'Open Sans', sans-serif",
  bookmarked: "yellow",
  bookmarkless: "grey",
};

export default GreenTheme;
